import sevenFamiliesToasterSrc from '~/src/assets/images/seven-families/toaster.png';
import {
  NOTIFICATION_COOLDOWN,
  STEP_CONFIG,
} from '~/src/common/components/SevenFamiliesGame/utils';
import { useFeatureFlag } from '~/src/common/services/FeatureFlag';
import I18n from '~/src/common/services/I18n';
import { useNiceModal } from '~/src/common/services/ModalsManager';
import Toaster from '~/src/common/services/Toaster';
import Tracker from '~/src/common/services/Tracker';
import { formatPrice } from '~/src/common/utils/prices';

import styles from './SevenFamilies.module.scss';

export const Notified = new Set();

const useSevenFamilies = () => {
  const isFFEnabled = useFeatureFlag('seven-families-game');
  const sevenFamiliesModal = useNiceModal('seven-families-modal');

  const notifyForStep = (step: number, amountLeftToReachStep: number) => {
    // Si le palier a déjà été notifié et est encore en cooldown, on ne fait rien
    if (Notified.has(step)) return;

    // On notifie et on marque le palier comme notifié
    Notified.add(step);
    Toaster.notify(
      {
        message: (
          <p className={styles.message}>
            {I18n.translate({
              value: 'seven-families.notification.message',
              amount: formatPrice(amountLeftToReachStep),
            })}
          </p>
        ),
        image: sevenFamiliesToasterSrc,
        actionButtonLabel: I18n.t('seven-families.notification.action'),
        onActionButtonClick: () => {
          void sevenFamiliesModal.show();
          Tracker.sendEvent('seven families informations modal viewed');
        },
      },
      { duration: 8_000 },
    );

    // On enlève le palier de la liste des notifiés à la fin du cooldown (10 mins)
    setTimeout(() => Notified.delete(step), NOTIFICATION_COOLDOWN);
  };

  const notifyForPrice = (price: number) => {
    // Aucune notification si le feature flag n'est pas activé
    if (!isFFEnabled) return;

    const offset = price - STEP_CONFIG.FIRST_STEP;
    const diffFromStep = offset % STEP_CONFIG.STEP_LENGTH;

    if (diffFromStep >= 0 && diffFromStep < STEP_CONFIG.STEP_RANGE) {
      const currentStepIndex = Math.floor(offset / STEP_CONFIG.STEP_LENGTH);
      const amountLeftToReachStep = STEP_CONFIG.STEP_RANGE - diffFromStep;
      notifyForStep(currentStepIndex, amountLeftToReachStep);
    }
  };

  const notifyForCartUpdates = (previousQuantity: number, newQuantity: number, price: number) => {
    if (newQuantity > previousQuantity) notifyForPrice(price);
  };

  return { notifyForCartUpdates };
};

export default useSevenFamilies;
